<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="right-side-bar-main-sec deposit_section">
            <div class="deposit-withdraw-sec">
                <div class="go-to-back-sec">
                    <a @click="$router.go(-1)">
                        {{ $t('back', 'Back') }}
                    </a>
                </div>
                <div class="dw_bg_cl">
                    <div class="type_of_deposit_parent" v-if="Object.keys(parentPaymentsList || {}).length">
                        <div class="description-card-body payment_type_tabs_cl">
                            <div class="row">
                                <div class="col-12">
                                    <div class="deposit_tabs_cl">
                                        <div class="wallet_thm_title">
                                            <h2>Choose a payment method</h2>
                                        </div>
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li v-for="(paymentData, payment) in parentPaymentsList" :key="payment" class="nav-item" role="presentation">
                                                <button class="nav-link" :class="{ active: activeTab === payment }, paymentBonus?.[paymentData?.[0]?.method_id] ? 'paymentBonus' : ''" @click="choosePaymentMethod(paymentData, payment)"
                                                data-bs-toggle="tab" :data-bs-target="'#tab-' + index" :id="'tabId' + index" role="tab" 
                                                type="button" :aria-controls="'tab-' + index" :aria-selected="index === 0">
                                                <div class="get-bonus-sec" v-if="paymentBonus?.[paymentData?.[0]?.method_id]">Get {{ paymentBonus?.[paymentData?.[0]?.method_id] }}% Bonus</div>
                                                    <figure class="deposit_fgr">
                                                        <figcaption>{{ payment }}</figcaption>
                                                        <img loading="lazy" :src="methodIcons[payment]" :alt="payment" />
                                                    </figure>
                                                </button>
                                            </li>
                                        </ul>
                                        <span v-if="accountDetails?.method == 'bank' && !isPaymentGateway">You can add through a bank transfer</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="description-card-body payment_type_tabs_content_cl">
                            <div class="payment-gateway-sec" v-if="isPaymentGateway">
                                <span>Pay using our payemnt gateway</span>
                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                            </div>
                            <div class="tab-content" id="myTabContent" v-if="!isPaymentGateway" >
                                <div class="tab-pane active" :id="'tab-' + index"
                                    role="tabpanel" :class="{ 'show active': index === 0 }" :aria-labelledby="'tabId' + index">
                                    <div class="depo-lft-container imps_deposit_sec imps_tabs_content">
                                        <div class="description-card-body account_data_parent_cl m-0">
                                            
                                            <div class="account-data"  v-for="(account, index) in paymentDetailsList" @click="changeAccount(account,index)" :key="index" :class="{ 'selected-card' : currentAccount === index }">
                                                <p class="card-text" v-if="account?.account_number || account?.phone_number">
                                                    {{ account?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number') }}
                                                        : <span>{{ account?.account_number ? account?.account_number : account?.phone_number }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(account?.account_number ? this.$t('account-number', 'Account Number') : this.$t('phone-number', 'Phone Number'), account.account_number ? account.account_number : account.phone_number,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text">
                                                    {{ account?.account_number ? $t('ifsc-code', 'IFSC Code') : account?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}
                                                        : <span>{{ account?.account_number ? account?.ifsc_code : (account?.upi_id || account?.crypto_wallet_id) }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(account.account_number ? this.$t('ifsc-code', 'IFSC Code') : account?.upi_id ? this.$t('upi-id', 'UPI ID') : this.$t('wallet-id', 'Wallet ID'), account.account_number ? account.ifsc_code : (account?.upi_id || account?.crypto_wallet_id),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text">{{ $t('display-name', 'Display Name') }}
                                                        : <span>{{ account?.account_holder_name }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(this.$t('display-name', 'Display Name'), account?.account_holder_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text" v-if="account?.crypto_wallet_id">
                                                    Deposit Amount
                                                        : <span>
                                                    {{ (depositAmount/account?.multiplier_value)?.toFixed(2) }} {{ account?.method_name}}
                                                    <span>( at x{{ Number(account?.multiplier_value) }} )</span>
                                                    </span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData('Deposit Amount', (depositAmount/account?.multiplier_value),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <div class="qrCode-pic" v-if="account.qr_code">
                                                    <div class="click-qr-preview-img" v-if="account.qr_code">
                                                        <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" 
                                                            @click="currentImgLink = account.qr_code">
                                                            <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                        </button>
                                                        <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrShareModal" 
                                                            @click="currentImgLink = account.qr_code">
                                                            <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                        </button>
                                                        <button class="click-qr-icons" 
                                                            @click="downloadQrImg(account.qr_code, account?.account_holder_name)">
                                                            <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                        </button>
                                                    </div>
                                                    <figure v-if="account.qr_code">
                                                        <img loading="lazy" :src="account.qr_code" alt="QR-Code">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="utr_proof_cl">
                                            <div class="form-group utr_file_input_grp" v-if="!previewImage">
                                                <label for="proofOfDeposit220225">{{ $t('upload-your-payment-proof', 'Upload Your Payment Proof') }} 
                                                    <small style="color: red;">[{{ $t('required', 'Required') }}]</small></label>
                                                <input type="file" class="form-control" @change="fileUpdateFunc" accept="image/png, image/jpg, image/jpeg, image/webp" />
                                            </div>
                                            <div v-if="init.transaction_image_url && !uploadedImage" class="error_cl" for="transactionId">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}.</div>
                                        </div>
                                        <div class="form-group" v-if="previewImage">
                                            <label>{{ $t('payment-slip', 'Payment Slip') }}</label>
                                            <div class="fileList deposit-previewImage">
                                                <img loading="lazy" class="fileList-img" :src="previewImage" alt="file-list"/>
                                                <button class="add-utr-again" @click="removeImage()">
                                                    &#10006;
                                                </button>
                                                <div class="timer loader_timer" v-if="utrLoader">
                                                <div class="loader_deposit">
                                                </div>
                                                <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                    {{ timerValue }}
                                                </text>
                                            </div>
                                            </div>
                                        </div>

                                        <div class="form-group amount_deposit_input amount_fillerd_inpt_box">
                                            <label for="transactionId">{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }}
                                                <small style="color: red;" v-if="accountDetails?.method != 'wallet'">*</small>
                                            </label>
                                            <input type="tel" :maxlength="accountDetails?.method != 'wallet' ? 15 : 128" class="form-control utr_input_cl" v-model="manual_utr" @input="validateUTR(), manualEnterUtr = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" />
                                            <div v-if="accountDetails?.method != 'wallet' && init.utr && !manual_utr?.length" class="error_cl">Please Enter UTR Number.</div>
                                            <div v-else-if="accountDetails?.method != 'wallet' && init.utr && manual_utr?.length < 10" class="error_cl">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</div>
                                        </div>

                                        <div class="form-group amount_deposit_input amount_fillerd_inpt_box">
                                            <label for="exampleFormControlInput1">{{ $t('amount', 'Amount') }} <small style="color: red;">*</small></label>
                                            <input type="number" class="form-control" v-model="depositAmount" readonly />
                                        </div>

                                        <input type="hidden" id="accountId" value="220225" />
                                        <div class="custom-control custom_checkbox_cl">
                                            <input type="checkbox"  class="form-check-input custom-control-input" v-model="termsAgreed" />
                                            <label class="custom-control-label" for="termsCheck220225">{{ $t('i-have-read-and-agree-with', 'I have read and agree with') }}
                                                <a href="#termsAndCondition" data-bs-toggle="modal" class="terms_condition_cl">
                                                    {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}.
                                                </a>
                                            </label>
                                        </div>
                                        <div class="submit_form_cl_div">
                                            <button type="button" class="withdrawBtn submit_form_cl" @click="walletDepositSubmitBtn()" :class="{ 'btn-loading': loading }">
                                                {{ $t('submit', 'Submit') }} <span><b></b><b></b><b></b></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no_deposit_parent text-center" v-else>
                        No Deposit Options Available. Contact Admin!!
                    </div>
                    <div class="description-card-body">
                        <div class="row">
                            <div class="col-12">
                                <WalletInstructions instructionType="deposit" />
                            </div>
                        </div>
                    </div>
                    <div class="deposit-main-body mt-2">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="depo-rgt-container deposit_amount_table_cl">
                                    <WalletHistory ref="wallet_history"></WalletHistory>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- term conditation modal pop up-->
    <div class="modal fade" id="termsAndCondition" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header headerTheme">
                    <h5 class="modal-title">
                        {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}
                    </h5>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close" data-original-title="" title="">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="term_condiation_body_wrapper p-0">
                        <p>
                        {{ $t('limits-the-maximum-deposit-limit-on-your-account', 'Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks.') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            {{ $t('please-contact-support', 'Please contact') }} 
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary " style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                            {{ $t('for-further-information', 'for further information') }}.
                        </span>
                        </p>

                        <p>
                        {{ $t('security-please-note-you-may-be-asked-to-supply', 'Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out more, please click here.') }}
                        </p>

                        <p>
                        {{ $t('withdrawals-withdrawals-will-be-directed-to-the-same-source', 'Withdrawals will be directed to the same source. If your query is not covered by the information contained here, please email') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary" style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                        </span>
                        {{ $t('where-staff-will-be-on-hand', 'where staff will be on hand to answer your query.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <!--qrPreview Modal -->
     <div class="modal fade" id="qrPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="qrPreview-image">
                        <img loading="lazy" :src="currentImgLink" alt="asg_rouletted1-thumb">
                    </div>
                    <div class="searchbar-main deposit-page-close">
                        <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="qrShareModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="qrShare-list">
                        <li>
                            <a :href="`https://wa.me/?text=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/whatsapp-share.svg" alt="whatsapp-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/facebook-share.svg" alt="facebook-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://t.me/share/url?url=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/telegram-share.svg" alt="telegram-share.svg">
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" @click="copyImgUrl" target="_blank">
                                <img loading="lazy" src="@/assets/images/instagram-share.svg" alt="facebook-share.svg">
                            </a>
                        </li>
                    </ul>
                    <div class="searchbar-main deposit-page-close">
                        <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">{{$t('close','Close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getParentPaymentsMethods, onUploadImage,submitDepositAmount, ocrCheck, getPaymentGatewayUrl} from '../services/depositPayment';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import WalletInstructions from '../components/WalletInstructions.vue';
import WalletHistory from '../components/WalletHistory.vue';
export default {
    name: 'DepositPaymentMethod',
    inject: ['walletConfig'],
    extends: ocrCheck,
    data() {
        return {
            paymentMethods: [],
            parentPaymentsList:null,
            paymentDetailsList: null,
            awsS3Path: '',
            bankS3url: '',
            awsS3QrCode: '',
            showFileError: false,
            showUtrError: false,
            selectedPaymentMethod: [],
            uploadedImage: null,
            manual_utr: null,
            userJourneyVideo: null,
            file: undefined,
            loading: false,
            walletData: null,
            selectPaymentAccount: null,
            previewImage: null,
            copiedText: null,
            walletLoading:false,
            currentImgLink: null,
            t: 6, 
            interval: 30, 
            angle: 0, 
            angle_increment: 360 / 9, 
            intervalCounter: 0,
            timerValue: 9, 
            timer: null, 
            utrLoader: false,
            utrerror:false,
            init:{
                utr: false,
                transaction_image_url:false
            },
            termsAgreed: false,
            utrLimitError:false,
            manual_utr: 0,
            currentAccount: 0,
            utrMsg: {
                langKey: 'enter-utr', 
                msg: "Kindly enter UTR Number manually for fast deposit."
            },
            isPaymentGateway: null,
            tesseract_utr: null,
            manualEnterUtr: 0
        }
    },
    components: {
        WalletHistory,
        WalletInstructions
    },
    computed: {
        ...mapGetters([
            'depositAmount','bonusData'
        ]),
        strokeDasharray() {
            return `${this.angle}, 361`;
        },
        methodIcons() {
            let iconObj = {};
            this.walletConfig?.payment_method?.forEach(element => {
                iconObj[element.method_name] = element.icon
            });
            this.walletConfig?.bank_list?.forEach(element => {
                iconObj[element.bank_name] = element.icon
            });
            return iconObj
        },
        paymentBonus() {
            if (!this.bonusData || !Array.isArray(this.bonusData)) {
                return {};
            }
        
            const paymentBonusData = this.bonusData.filter(bd => bd.bonusType === 'payment bonus');
            
            if (paymentBonusData.length === 0) {
                return {};
            }
            
            return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
                try {
                    const methodIds = JSON.parse(bonusElement.methodIds);
                    if (Array.isArray(methodIds)) {
                        methodIds.forEach(methodId => {
                            methodBonusMap[methodId] = bonusElement.percentage;
                        });
                    }
                } catch (error) {
                    console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
                }
                return methodBonusMap;
            }, {});
        }
    },
    mounted() {
        this.getParentPaymentMethods();
    },
    methods: {
        sanitizeInput() {
            this.manual_utr = this.manual_utr?.replace(/\D+/g, '');
        },
        changeAccount(account, index){
            this.currentAccount = index
            this.accountDetails = account
            this.toggleInit(false)
            this.clearPaymentSlip()
        },
        startTimer() {
            this.utrLoader = true;
            this.angle = 0;
            this.intervalCounter = 0;
            this.timerValue = this.t;

            if (this.timer) {
                clearInterval(this.timer);
            }

            this.timer = setInterval(() => {
                this.intervalCounter++;
                this.angle = (this.intervalCounter / (this.t * (1000 / this.interval))) * 360;

                this.timerValue = this.t - Math.floor((this.angle / 360) * this.t);

                if (this.timerValue <= 0) {
                    this.resetTimer();
                    this.utrLoader = false;
                }
            }, this.interval);
        },
        async goToPaymentGateway() {
            try {
                const response = await getPaymentGatewayUrl(this.depositAmount, this.paymentDetailsList[0].master_account_id);
                console.log(response)
            } catch (error) {
                this.$errorToast(error)
            }
        },
        clearPaymentSlip() {
            this.previewImage = null;
            this.manual_utr = '';
            this.file = undefined;
            this.utrLimitError = '';
            this.utrerror = '';
            this.uploadedImage = null;
        },
        copyPaymentData(catagory, accountData) {
            if (!accountData) {
                this.$errorToast(this.$t('no-data-available-to-copy', 'No Data Available To Copy.'));
                return;
            }
            if (navigator.clipboard) {
                navigator.clipboard.writeText(accountData).then(() => {
                    this.$successToast(catagory + ' Copied Successfully');
                }).catch(err => {
                    console.error("Failed to copy text");
                });
            } 
            else{
                var input = document.createElement('textarea');
                input.innerHTML = accountData;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.copiedText = accountData;
                this.$successToast(catagory + ' Copied Successfully');
            }
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = ''; 
            });
            setTimeout(() => {
                this.copiedText = null;
                document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
                    el.style.color = '#0cddff';
                });
            }, 1000);
        },
        selectPaymentMethodAccount(paymentAccount) {
            this.selectPaymentAccount = paymentAccount.agent_bank_id;
        },
        async getParentPaymentMethods(reconnectTry = 0) {
            try {
                let response = await getParentPaymentsMethods( reconnectTry, this.depositAmount );
                if(response?.data){
                    this.parentPaymentsList = response?.data;
                    let nonSocialStartIndex = response?.nonSocialStartIndex
                    this.activeTab = Object.keys(this.parentPaymentsList)[nonSocialStartIndex]
                    this.choosePaymentMethod(this.parentPaymentsList[this.activeTab], this.activeTab);
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        choosePaymentMethod(payment, index){
            this.clearPaymentSlip()
            this.toggleInit(false)
            if(payment?.[0]?.method == 'social'){
                const socialNumber = payment?.[0]?.social_payment_number;
                const socialLink = payment?.[0]?.social_payment_link;
                if (socialNumber?.length && socialLink?.length) {
                    const choice = Math.random() < 0.5 ? 'number' : 'link';
                    if (choice === 'number') {
                        if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                            window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                        } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                            window.open(`https://t.me/${socialNumber}`, 'blank');
                        }
                    } else {
                        window.open(socialLink, 'blank');
                    }
                    return;
                }
                if (socialNumber?.length) {
                    if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                        window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                    } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                        window.open(`https://t.me/${socialNumber}`, 'blank');
                    }
                    return;
                }
                if (socialLink?.length) {
                    window.open(socialLink, 'blank');
                    return;
                }
                this.$errorToast(this.$t('no-social-payment-number', 'No social payment number available'));
                return;
            }
            if(payment?.[0]?.method == 'payment_gateway'){
                this.isPaymentGateway = true;
                this.paymentDetailsList = payment;
                return
            }
            this.activeTab = index
            this.currentAccount = 0
            this.currentPaymentId = payment?.[0]?.method
            this.paymentDetailsList = payment
            this.AccountS3Url = payment?.qr_code
            this.accountDetails = this.paymentDetailsList?.[0]
            this.isPaymentGateway = false;
        },
        toggleInit(bool){
            this.init = {
                utr: bool,
                transaction_image_url: bool
            }
        },
        removeImage(){
            this.uploadedImage = null
            this.previewImage = null
            this.manual_utr = ''
        },
        async walletDepositSubmitBtn() {
            try {
                this.termsAgreed = true;
                this.toggleInit(true);
                if(this.accountDetails?.method != 'wallet' && this.manual_utr?.length < 11) return;
                let response = await submitDepositAmount({
                    accountDetails: this.accountDetails,
                    uploadedImage: this.uploadedImage,
                    depositAmount: this.depositAmount,
                    manual_utr: this.manual_utr,
                    removeImage: this.removeImage,
                    has_edited_utr: this.manualEnterUtr
                });
                
            } catch (error) {
                console.log(error);
                
                this.$errorToast(error)
            }
        },
        validateUTR(){
            this.manual_utr = this.manual_utr?.replace(/[^0-9]/g, '').replace(/[+-]/g, '')
            if (this.manual_utr == null || this.manual_utr == '') 
                this.utrerror = true;
            else if (this.manual_utr?.length < 10 || this.manual_utr?.length > 15) 
                this.utrLimitError = true;
            else
                this.utrLimitError = false;
                this.utrerror = false;
        },
        resetTimer() {
            clearInterval(this.timer);
            this.utrLoader = false;
            this.angle = 0;
            this.intervalCounter = 0;
            this.timerValue = this.t;
        },
        async fileUpdateFunc(event) {
            try {
                const file = event.target.files[0];
                this.previewImage = URL.createObjectURL(file)
                let response = await onUploadImage({
                    event,
                    depositAmount: this.depositAmount,
                    startTimer: this.startTimer,
                    resetTimer: this.resetTimer,
                    sbtBtn: this.$refs.sbtBtn,
                    checkAll: this.checkAll
                });
                if(response){
                    this.manual_utr = response?.manual_utr
                    this.utrMsg = response?.utrMsg
                    this.uploadedImage = response?.uploadedImage
                    this.previewImage = response?.previewImage
                    this.tesseract_utr = response?.tesseract_utr
                    this.utrLoader = false
                }
                else{
                    this.previewImage = null
                }
            } catch (error) {
                this.previewImage = null
                this.$errorToast(error)
            }
        },
        copyImgUrl() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.currentImgLink).then(() => {
                    this.$successToast('Successfully copied.');
                }).catch(err => {
                    console.error("Failed to copy text");
                });
            } 
            else{
                var input = document.createElement('textarea');
                input.innerHTML = this.currentImgLink;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$successToast('Successfully copied.');
            }
            
        },
        downloadQrImg(imageUrl, name) {
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = name;
            link.target = '_blank';
            link.click();
        },
    }
}
</script>
<style>
.what-deposit {
    max-width: none !important;
}
</style>